'use strict'

const _ = require('lodash')

/**
 * shallow resolve object references to definitionsMap
 * merge referenced data to the referring object
 * flatten 'allOf' array to single object
 * @param definitionsMap
 * @param obj
 */
const resolve = (definitionsMap, obj) => {
    let result = {}
    _.forOwn(obj, (value, key) => {
        const isArray = Array.isArray(value)
        if (typeof value === 'object' && !isArray) {
            result[key] = resolve(definitionsMap, value)
        } else if (key === 'allOf' && isArray) {
            result = resolve(definitionsMap, _.merge({}, ...value))
        } else if (key === '$ref') {
            if (definitionsMap.baseDefinitions[value]) {
                result = _.defaultsDeep({}, {origin: 'base'}, obj, definitionsMap.baseDefinitions[value])
            } else if (definitionsMap.customDefinitions[value]) {
                result = _.defaultsDeep({}, {origin: 'custom'}, obj, definitionsMap.customDefinitions[value])
            }
            return false
        } else {
            result[key] = value
        }
        return true
    })
    return result
}

/**
 * return key formatted for the definitionMap from definition
 * @param def
 * @returns {string} definition key
 */
const keyByDefId = def => `${def.$id}`

/**
 * map base and custom definitions to format used by resolver
 * @param baseDefinitions
 * @param customDefinitions
 * @returns {{baseDefinitions: *, customDefinitions: *}}
 */
const update = (baseDefinitions, customDefinitions) => ({
    baseDefinitions: _.keyBy(baseDefinitions, keyByDefId),
    customDefinitions: _.keyBy(customDefinitions, keyByDefId)

})

/**
 * create resolver that can shallow resolve objects based on definitions
 * @param baseDefinitions
 * @param customDefinitions
 * @returns {{resolve: (), update: ()}}
 */
const createResolver = (baseDefinitions = {}, customDefinitions = {}) => {
    let definitionsMap = update(baseDefinitions, customDefinitions)
    return {
        resolve: obj => resolve(definitionsMap, obj),
        update: (updatedBaseDefinitions, updatedCustomDefinitions) => {
            definitionsMap = update(updatedBaseDefinitions, updatedCustomDefinitions)
        }
    }
}

module.exports = {
    createResolver
}

